export enum SignInSearchParams {
  CallbackUrl = "callbackUrl",
}
